<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <!--Document Group FORM-->
            <template v-if="type === 'form'">
                <v-toolbar-title >{{ formTitle }}</v-toolbar-title>
            </template>
            <!--Document Group VIEW TABLE-->
            <template v-if="type === 'view'">
                <v-toolbar-title>{{tableTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <responsiveButton :setTo="getRouteToAdd"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                >
                    {{buttonTitle}}
                </responsiveButton>
            </template>
        </v-toolbar>
        <v-divider class="my-0 mx-6"></v-divider>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    import {DOCUMENT_GROUP_TYPES} from "@/shared/enums/DocumentGroup";

    export default {
        name: "DocumentGroupHeader",
        components:{responsiveButton},
        props:["hType", "tId", "tAction","docType"],
        data(){
            return{
                type: this.hType,
                id: this.tId,
                action: this.tAction,
                documentType: this.docType
            }
        },
        watch:{
            hType(value){
                this.type = value;
            },
            tId(value){
                this.id = value;
            },
            tAction(value){
                this.action = value;
            },
            docType(value){
                this.documentType = value;
            }
        },
        computed:{
            typeTitle(){
                return this.documentType === DOCUMENT_GROUP_TYPES.REPORT ? 'report' : 'document';
            },
            formTitle(){
                return this.id ? `${this.$options.filters.upperCaseFirstLetter(this.action)} ${this.typeTitle} category` : `New ${this.typeTitle} category`;
            },
            tableTitle(){
                return `${this.$options.filters.upperCaseFirstLetter(this.typeTitle)} Categories Table`;
            },
            buttonTitle(){
                return `Add ${this.$options.filters.upperCaseFirstLetter(this.typeTitle)} Category`;
            },
            getRouteToAdd(){
                return this.documentType === DOCUMENT_GROUP_TYPES.REPORT ? "/orgWorkSpace/report-group/add" : "/orgWorkSpace/document-group/add"
            }
        }
    }
</script>

<style scoped>

</style>